<template>
    <main class="background py-5" style="margin: 0 0 !important;">
        <section class="title">
            <h1>Tic Tac Toe</h1>
        </section>
        <section class="display float-board p-3">
            <div class="row">
                <div class="col nowrap">
                    Room ID: {{ roomId }}
                </div>
            </div>
            <div class="row">
                <div v-if="this.player['X']" class="col nowrap playerX">
                    {{ this.player['X'].id }} (X): {{ this.player['X'].point }}
                </div>
                <div v-if="currentPlayer == 'X'" class="col nowrap mx-3">
                    <span class="display-player playerX"><i class="fas fa-comment-dots text-light" style="font-family: 'Font Awesome 5 Free'"></i></span>
                </div>
            </div>
            <div class="row">
                <div v-if="this.player['O']" class="col nowrap playerO">
                    {{ this.player['O'].id }} (O): {{ this.player['O'].point }}
                </div>
                <div v-if="currentPlayer == 'O'" class="col nowrap mx-3">
                    <span class="display-player playerO"><i class="fas fa-comment-dots text-light" style="font-family: 'Font Awesome 5 Free'"></i></span>
                </div>
            </div>
            <div class="row">
                <section class="controls">
                    <button id="reset" @click="askReset()" :disabled="waitReset">{{ waitReset ? 'Asking' : 'New Game' }}</button>
                    <button class="btn btn-secondary" @click="askLeave()">Leave Room</button>
                </section>
            </div>
        </section>
        <section class="row" style="flex-direction: column; margin: 0 auto;">
            <div v-for="i in boardWidth" :key="i" class="row">
                <div v-for="j in boardWidth" :key="j" @click="choose(i, j)" :ref="'tile-'+i+'-'+j" class="tile" 
                    :style="{ 'min-width': tileWidth + 'px', 'min-height': tileWidth + 'px', 'font-size': tileWidth / 2 + 'px', }"></div>
            </div>
        </section>
    </main>
</template>

<script>
import { firebaseInit } from '@/api/firebase.js';
import modal from '@/utils/modal.js'

export default {
    data(){
        return {
            db: {},
            roomId: '',
            userId: '',
            boardWidth: 20,
            currentPlayer: 'X',
            currentTile: null,
            moves: [],
            gameDone: false,
            player: {},
            waitReset: false,
            hasResetAlert: false,
            tileWidth: 50,
        }
    },
    methods: {
        roomSnapshotInit(){
            this.db.collection('rooms').doc(this.roomId)
            .onSnapshot((querySnapshot) => {
                let data = querySnapshot.data()
                if(!data) return
                this.player = data.player ?? {
                    'X': {
                        id: this.userId,
                        point: 0,
                    },
                    'O': {
                        id: '',
                        point: 0,
                    },
                }
                if(this.player['X'].id == '' || this.player['O'].id == '') this.$toast.info(this.centerToast('Need 1 more player!'))

                this.gameDone = !!data.gameDone

                if(data.winner == this.userId){
                    let winner = this.currentPlayer == 'X' ? 'O' : 'X'
                    if(this.player[winner].id == this.userId){
                        this.player[winner].point++
                        this.db.collection('rooms').doc(this.roomId).set({
                            moves: this.moves,
                            player: this.player,
                            gameDone: true,
                        }).catch((error) => {
                            console.error("Error adding document: ", error);
                        });
                    }
                }

                this.moves = data.moves ?? []
                this.moves.forEach(val => {
                    let coodinate = val.split('-')
                    this.tick(coodinate[0], coodinate[1], coodinate[2])
                })
                if(this.moves.length > 0){
                    let lastMove = this.moves[this.moves.length - 1].split('-')
                    this.currentPlayer = lastMove[0] == 'X' ? 'O' : 'X'
                    this.currentTile = [lastMove[1], lastMove[2]]
                }
                if(data.reset){
                    if(this.userId != data.reset){
                        if(!this.hasResetAlert){
                            this.hasResetAlert = true
                            modal({
                                text: 'Player '+ data.reset +' wants to play a new game.',
                                stick: true,
                            },
                            () => {
                                this.hasResetAlert = false
                                this.db.collection('rooms').doc(this.roomId).set({
                                    moves: [],
                                    player: this.player,
                                }).catch((error) => {
                                    console.error("Error adding document: ", error);
                                });
                            },
                            () => {
                                this.hasResetAlert = false
                                this.db.collection('rooms').doc(this.roomId).set({
                                    moves: this.moves,
                                    player: this.player,
                                    gameDone: this.gameDone,
                                }).catch((error) => {
                                    console.error("Error adding document: ", error);
                                });
                            } )
                        }
                    }
                } else if(data.moves.length == 0){
                    if(this.player['X'].id == '' || this.player['O'].id == '') return
                    this.resetBoard()
                    this.waitReset = false
                    this.gameDone = false
                    this.$toast.success(this.centerToast((this.player['X'].id == this.userId ? this.player['O'].id : this.player['X'].id) + ' Agrees on Starting a New game.'))
                } else if(this.waitReset){
                    this.waitReset = false
                    this.$toast.error(this.centerToast((this.player['X'].id == this.userId ? this.player['O'].id : this.player['X'].id) + ' Refuses on Starting a New game.'))
                }
            });
        },
        choose(i, j){
            if(this.gameDone) return this.$toast.success(this.centerToast('The Game Has Already Over.'))
            if(!this.player[this.currentPlayer]) return // no data yet
            if(this.player[this.currentPlayer].id != this.userId) return this.$toast.info(this.centerToast('Not your turn yet!')) 
            let chosenTile = this.$refs['tile-'+i+'-'+j][0]
            if(chosenTile.innerHTML == 'X' || chosenTile.innerHTML == 'O') return // cant choose marked tile
            this.moves.push(this.currentPlayer+'-'+i+'-'+j)
            this.db.collection('rooms').doc(this.roomId).set({
                moves: this.moves,
                player: this.player,
            }).catch((error) => {
                console.error("Error adding document: ", error);
            });
        },
        tick(player, i, j){ // TODO make double tick
            let tile = this.$refs['tile-'+i+'-'+j][0]
            if(!tile) return
            if(tile.innerHTML == 'X' || tile.innerHTML == 'O') return
            tile.innerHTML = player
            tile.classList.add('player' + player);
            tile.classList.add('current-tile');
            if(this.currentTile){
                this.$refs['tile-'+this.currentTile[0]+'-'+this.currentTile[1]][0].classList.remove('current-tile')
            }
            this.currentTile = [i, j]
            this.checkWin(player, i, j)
        },
        checkWin(player, i, j){
            let x, y
            let count = {
                downRight: 0,
                downLeft: 0,
                upRight: 0,
                upLeft: 0,
                right: 0,
                left: 0,
                down:0,
                up: 0,
            }
            x = +j+1
            y = +i
            while(this.$refs['tile-'+y+'-'+x]?.[0].innerHTML == this.currentPlayer){
                count.right++
                x++
            }
            x = +j-1
            y = +i
            while(this.$refs['tile-'+y+'-'+x]?.[0].innerHTML == this.currentPlayer){
                count.left++
                x--
            }
            x = +j
            y = +i+1
            while(this.$refs['tile-'+y+'-'+x]?.[0].innerHTML == this.currentPlayer){
                count.down++
                y++
            }
            x = +j
            y = +i-1
            while(this.$refs['tile-'+y+'-'+x]?.[0].innerHTML == this.currentPlayer){
                count.up++
                y--
            }
            x = +j+1
            y = +i+1
            while(this.$refs['tile-'+y+'-'+x]?.[0].innerHTML == this.currentPlayer){
                count.downRight++
                x++
                y++
            }
            x = +j-1
            y = +i-1
            while(this.$refs['tile-'+y+'-'+x]?.[0].innerHTML == this.currentPlayer){
                count.upLeft++
                x--
                y--
            }
            x = +j+1
            y = +i-1
            while(this.$refs['tile-'+y+'-'+x]?.[0].innerHTML == this.currentPlayer){
                count.upRight++
                x++
                y--
            }
            x = +j-1
            y = +i+1
            while(this.$refs['tile-'+y+'-'+x]?.[0].innerHTML == this.currentPlayer){
                count.downLeft++
                x--
                y++
            }
            if(count.right + count.left > 3 || count.down + count.up > 3 || count.downRight + count.upLeft > 3 || count.upRight + count.downLeft > 3){
                let iWin = this.player[player].id == this.userId
                modal({ text: iWin ? 'You Win!' : 'You Lose!', title: 'Game Over', icon: iWin ? 'success' : 'error' })
                if(this.gameDone || !iWin) return true
                this.db.collection('rooms').doc(this.roomId).set({
                    moves: this.moves,
                    player: this.player,
                    gameDone: true,
                    winner: this.userId,
                }).catch((error) => {
                    console.error("Error adding document: ", error);
                });
                return true
            }
        },
        askReset(){
            if(this.moves && this.moves.length > 0){
                this.waitReset = true
                this.db.collection('rooms').doc(this.roomId).set({
                    reset: this.userId,
                    moves: this.moves,
                    player: this.player,
                    gameDone: this.gameDone,
                }).catch((error) => {
                    console.error("Error adding document: ", error);
                });
            } else this.$toast.success(this.centerToast('A New Game is Started.'))
        },
        resetBoard(){
            if(this.currentTile){
                try{
                    this.$refs['tile-'+this.currentTile[0]+'-'+this.currentTile[1]][0].classList.remove('current-tile')
                } catch(e){
                    console.log('Cant find this tile', 'tile-'+this.currentTile[0]+'-'+this.currentTile[1], this.$refs['tile-'+this.currentTile[0]+'-'+this.currentTile[1]])
                }
            }
            for(let i = 1; i <= this.boardWidth; i++){
                for(let j = 1; j <= this.boardWidth; j++){
                    try{
                        this.$refs['tile-'+i+'-'+j][0].innerHTML = ''
                        this.$refs['tile-'+i+'-'+j][0].classList.remove('playerX')
                        this.$refs['tile-'+i+'-'+j][0].classList.remove('playerO')
                    } catch(e){
                        // console.log('Cant find this tile', 'tile-'+i+'-'+j, this.$refs['tile-'+i+'-'+j])
                    }
                }
            }
        },
        askLeave(){
            modal({ 
                text: 'Do you really want to leave?',
                icon: 'question',
                iconColor: 'red',
                showCancelButton: true
            }, this.leaveRoom)
        },
        leaveRoom(){
            if(this.player['X'].id == this.userId) this.player['X'] = { id: '', point: 0 }
            else this.player['O'] = { id: '', point: 0 }
            if(this.player['X'].id == '' && this.player['O'].id == ''){
                this.db.collection('rooms').doc(this.roomId).delete()
                .catch(e => console.log(e))
                this.$router.push({ name: 'XOLogin' })
                return
            }
            this.db.collection('rooms').doc(this.roomId).set({
                moves: [],
                player: this.player,
            }).catch(e => console.log(e))
            this.$router.push({ name: 'XOLogin' })
        },
        centerToast(text){
            return { text, position: 'center', toast: false }
        },
    },
    mounted(){
        $('html').css('min-width', 'fit-content')
        if(this.$isMobile()) this.tileWidth = 25
    },
    created(){
        this.roomId = this.$route.params.roomId;
        this.userId = this.$route.params.userId;
        this.db = firebaseInit();
        this.roomSnapshotInit();
        this.db.collection('rooms').doc(this.roomId).get()
        .then(doc => {
            if (doc.exists) {
                let data = doc.data()
                let player = data.player
                if(!player){
                    this.player = {
                        'X': {
                            id: this.userId,
                            point: 0,
                        },
                        'O': {
                            id: '',
                            point: 0,
                        },
                    }
                    this.db.collection('rooms').doc(this.roomId).set({
                        moves: [],
                        player: this.player,
                    }).catch(e => console.log(e))
                    return
                }
                if(player['X'].id == ''){
                    player['X'].id = this.userId

                    this.db.collection('rooms').doc(this.roomId).set({
                        moves: data.moves,
                        player,
                    }).catch(e => console.log(e))
                }
                else if(player['X'].id != this.userId && player['O'].id == ''){
                    player['O'].id = this.userId

                    this.db.collection('rooms').doc(this.roomId).set({
                        moves: data.moves,
                        player,
                    }).catch(e => console.log(e))
                }
                this.player = player
            } else {
                this.player = {
                    'X': {
                        id: this.userId,
                        point: 0,
                    },
                    'O': {
                        id: '',
                        point: 0,
                    },
                }
                this.db.collection('rooms').doc(this.roomId).set({
                    moves: [],
                    player: this.player,
                }).catch(e => console.log(e))
            }
        }).catch(e => console.log(e))

    },
}
</script>

<style scoped>
@import url(https://fonts.googleapis.com/css2?family=Itim&display=swap);

* {
    padding: 0;
    margin: 0;
    font-family: 'Itim', cursive;
}

.row {
    flex-wrap: nowrap;
    width: fit-content;
}

.float-board{
    position: fixed;
    top: 0;
    background-color: #12181bab;
    border: 1px solid white;
}

.nowrap{
    white-space: nowrap;
}

.current-tile{
    background: #4c4141;
    /* border-style: dashed !important; */
}

.background {
    background-color: #12181B;
    padding-top: 1px;
}

.title {
    color: white;
    text-align: center;
    font-size: 40px;
}

.display {
    color: white;
    font-size: 25px;
    text-align: center;
    margin-top: 1em;
    margin-bottom: 1em;
}

.hide {
    display: none;
}

.container {
    margin: 0 auto;
    flex-direction: column;
}

.tile {
    border: 1px solid grey;
    min-width: 50px;
    min-height: 50px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 25px;
    cursor: pointer;
}

.playerX {
    color: #09C372;
}

.playerO {
    color: #c1aa07;
}

.controls {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    margin-top: 1em;
}

.controls button {
    color: white;
    padding: 8px;
    border-radius: 8px;
    border: none;
    font-size: 20px;
    margin-left: 1em;
    cursor: pointer;
}

.restart {
    background-color: #498AFB;
}

#reset {
    background-color: #FF3860;
}
</style>